<template>
	<div box class="localhost">
		<!-- <p desc>{{$t("update.localhostInfo")}}</p> -->
		<ul>
			<li localhost data-desc="">

        <el-steps :active="active" finish-status="success">

          <el-step :title="$t('update.connectTit')" :description="$t('update.descConnect')"></el-step>
          <el-step :title="$t('update.cloud.checkUpdate')" :description="$t('update.cloud.checkUpdateInfo')"></el-step>
          <!-- <el-step :title="$t('update.intoBOOT')" :description="$t('update.descBOOT')"></el-step> -->
          <el-step :title="$t('update.successUpdate')" :description="$t('update.infouccessUpdate')"></el-step>
        </el-steps>
    
        <ul>
          <li v-show="active == 0">
            <el-button @click="infoConnect"> + {{$t('update.descConnect')}}</el-button>
          </li>

          <li v-show="active == 1">

            <!-- <el-upload class="upload-demo" action="#" auto-upload="false" accept=".bin" limit="1" show-file-list="true" 
            auto-upload="false" 
            :file-list="fileList"
            :on-change="handleFileChange"
            :before-upload="beforeUpload"><el-button size="small" type="primary" v-show="showCheck">{{$t('update.localhost.selectFileButton')}}</el-button></el-upload> -->

            <el-row info style="margin: 10px 5px 15px 0;padding-left: 0;">
              <span class="infoT">{{$t('update.curFirmware')}}：{{FirmwareFull}}</span>
              <span class="infoT">{{$t('update.runMode')}}：{{RunMode==0?$t('update.appMode'):$t('update.bootMode')}}</span>
            </el-row>

            <el-button v-show="showCheck" @click="check">{{$t('update.cloud.check')}}</el-button>

            <div op>
              <el-progress :percentage="percentage" v-show="showProgress"></el-progress>
              <el-button v-show="showBoot" @click="intoBOOT">{{$t('update.cloud.manualUpdate')}}</el-button>
              <el-button v-show="showStart" @click="startUpgrade">{{$t('update.cloud.startUpdate')}}</el-button>
            </div>
          </li>

          <!-- <li v-show="active == 2">

            <el-row info style="margin: 10px 5px 15px 0;padding-left: 0;">
              <span class="infoT">{{$t('update.curFirmware')}}：{{FirmwareFull}}</span>
              <span class="infoT">{{$t('update.runMode')}}：{{RunMode==0?$t('update.appMode'):$t('update.bootMode')}}</span>
            </el-row>
            <el-button @click="intoUpgrade">{{$t('update.intoBOOT')}}</el-button>
          </li> -->

          <li v-show="active == 3">
            <el-button type="success" @click="upgradeSuccess">{{$t('update.infoComplete')}}</el-button>
          </li>
        </ul>
    
			</li>
    </ul>
</template>

<script>
import axios from 'axios';
import KeyboardMapConf from '../../theme/keyboard.map.json';
import cmd10 from '../../theme/cmd1.0.config.json';
import { ToolsHandle } from '../../utils/tools.js';
// 命令数据功能操作对象
import { CommandHandle } from '../../utils/command_handle.js';
// 导入HIDDIVICE 硬件通讯模块
import { HIDDeviceObj } from '../../asserts/js/hid_device.js';
import { HIDDeviceUpgradeObj } from '../../asserts/js/hid_upgrade.js';
import '../../asserts/css/update/localhost.css';

export default {
  name: 'localhostUpdate',
  data() {
    return {
      ThemeConf:null,
      HIDDeviceObj:null,
      FirmwareFull:"-",
      RunMode:-1,
      active: 0,
      md5:"",
      fileList:[],
      showBoot:false,
      showCheck:true,
      showStart:false,
      showProgress:false,
      FirmwareBuffer:[],
      percentage:1,

      modelNumber:"",
      lastVer:-1,

    }
  },
  methods: 
  {
    init(curDeviceHandle)
    {
        if(curDeviceHandle.curDeviceHandle == null)
        {
          this.active = 0;
          return;
        }

        this.active = 1;
        this.HIDDeviceObj = curDeviceHandle;
        this.setCurModel();

        this.FirmwareFull = this.HIDDeviceObj.FirmwareFull;
        this.RunMode = this.HIDDeviceObj.RunMode;

        if(this.FirmwareFull)
        {
          this.showCheck = true;
        }

        if(this.RunMode)
        {
          this.showCheck = false;
          this.showBoot = false;
          this.showStart = true;
        }
    },
    setCurModel()
    {
      this.productList = this.ThemeConf.DeviceList;
      for(let i=0;i<this.productList.length;i++)
      {
        if(this.productList[i].FirmwareVer == this.HIDDeviceObj.FirmwareVer)
        {
            this.modelNumber = this.productList[i].model;
            this.lastVer = this.productList[i].lastVer;
        }
      }
    },
    infoConnect()
    {
      this.$message({message:this.$i18n.t("update.infoConnect"),type: 'warning',center: true,offset:300,'show-icon':true});
    },
    async erase()
    {
      //签名
      let SNDatas = this.HIDDeviceObj.SNDatas;
      let SNSignDatas = HIDDeviceUpgradeObj.blSignature(SNDatas,HIDDeviceUpgradeObj.blSignatureKey,HIDDeviceUpgradeObj.blSignatureParams,0x02);

      let SIGN1_CMD = new Uint8Array(cmd10.SET_DEVICE_SIGN1_CMD.map(hex => parseInt(hex, 16)));
          SIGN1_CMD = this.HIDDeviceObj.mergeUint8Arrays([SIGN1_CMD,[0x10],SNSignDatas,[0x10],SNDatas,[0xFF,0xFF,0xFF,0xFF]]);
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN1_CMD);

      await ToolsHandle.delay(20);
      let SignSN = this.HIDDeviceObj.SignDatas;
      let SignDatas = HIDDeviceUpgradeObj.blSignature(SignSN,HIDDeviceUpgradeObj.blSignatureKey,HIDDeviceUpgradeObj.blSignatureParams,0x03);

      let SIGN2_CMD = new Uint8Array(cmd10.SET_DEVICE_SIGN2_CMD.map(hex => parseInt(hex, 16)));
          SIGN2_CMD = this.HIDDeviceObj.mergeUint8Arrays([SIGN2_CMD,[0x10],SignDatas,[0x10],SignSN,[0xFF,0xFF,0xFF,0xFF]]);
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN2_CMD);


      await ToolsHandle.delay(20);
      let ERASE_CMD =  HIDDeviceUpgradeObj.getFirmwareBufferLenCommand(this.FirmwareBuffer.length,cmd10);
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, ERASE_CMD);
      await ToolsHandle.delay(100);


      this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN1_CMD);
      await ToolsHandle.delay(20);
      SignSN = this.HIDDeviceObj.SignDatas;
      SignDatas = HIDDeviceUpgradeObj.blSignature(SignSN,HIDDeviceUpgradeObj.blSignatureKey,HIDDeviceUpgradeObj.blSignatureParams,0x04);

      let SIGN4_CMD = new Uint8Array(cmd10.SET_DEVICE_SIGN4_CMD.map(hex => parseInt(hex, 16)));
          SIGN4_CMD = this.HIDDeviceObj.mergeUint8Arrays([SIGN4_CMD,[0x10],SignDatas,[0x10],SignSN,[0xFF,0xFF,0xFF,0xFF]]);

      this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN4_CMD);
      await ToolsHandle.delay(20);
    },
    async bootMode()
    {
      //签名
      let SNDatas = this.HIDDeviceObj.SNDatas;
      let SNSignDatas = HIDDeviceUpgradeObj.blSignature(SNDatas,HIDDeviceUpgradeObj.blSignatureKey,HIDDeviceUpgradeObj.blSignatureParams,0x02);

      let SIGN1_CMD = new Uint8Array(cmd10.SET_DEVICE_SIGN1_CMD.map(hex => parseInt(hex, 16)));
          SIGN1_CMD = this.HIDDeviceObj.mergeUint8Arrays([SIGN1_CMD,[0x10],SNSignDatas,[0x10],SNDatas,[0xFF,0xFF,0xFF,0xFF]]);
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN1_CMD);

      await ToolsHandle.delay(20);
      let SignSN = this.HIDDeviceObj.SignDatas;

      let SignDatas = HIDDeviceUpgradeObj.blSignature(SignSN,HIDDeviceUpgradeObj.blSignatureKey,HIDDeviceUpgradeObj.blSignatureParams,0x03);

      let SIGN2_CMD = new Uint8Array(cmd10.SET_DEVICE_SIGN2_CMD.map(hex => parseInt(hex, 16)));
          SIGN2_CMD = this.HIDDeviceObj.mergeUint8Arrays([SIGN2_CMD,[0x10],SignDatas,[0x10],SignSN,[0xFF,0xFF,0xFF,0xFF]]);
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN2_CMD);


      await ToolsHandle.delay(20);
      const ERASE_CMD = new Uint8Array(cmd10.SET_DEVICE_SIGN_ERASE_CMD.map(hex => parseInt(hex, 16)));
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, ERASE_CMD);
      await ToolsHandle.delay(100);


      this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN1_CMD);
      await ToolsHandle.delay(20);
      SignSN = this.HIDDeviceObj.SignDatas;
      SignDatas = HIDDeviceUpgradeObj.blSignature(SignSN,HIDDeviceUpgradeObj.blSignatureKey,HIDDeviceUpgradeObj.blSignatureParams,0x04);

      let SIGN4_CMD = new Uint8Array(cmd10.SET_DEVICE_SIGN4_CMD.map(hex => parseInt(hex, 16)));
          SIGN4_CMD = this.HIDDeviceObj.mergeUint8Arrays([SIGN4_CMD,[0x10],SignDatas,[0x10],SignSN,[0xFF,0xFF,0xFF,0xFF]]);

      this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN4_CMD);
      await ToolsHandle.delay(20);

      const REBOOT_CMD = new Uint8Array(cmd10.SET_DEVICE_SIGN_REBOOT_CMD.map(hex => parseInt(hex, 16)));
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, REBOOT_CMD);

    },
    check()
    {
        console.log(this.HIDDeviceObj.FirmwareNum);
        console.log(this.lastVer);
        
        //检查版本
        if(this.lastVer == this.HIDDeviceObj.FirmwareNum)
        {
          this.$message({message:this.$i18n.t("update.cloud.lastVerInfo"),type: 'success',center: true,offset:300,'show-icon':true});
          return;
        }

        this.$confirm(this.$i18n.t("update.cloud.confirmInfoCheck"), this.$i18n.t("update.cloud.confirmTitCheck"), 
        {
          confirmButtonText: this.$i18n.t("update.cloud.confirmOKCheck"),
          cancelButtonText: this.$i18n.t("update.cloud.confirmNoCheck"),
          type: 'warning'
        }).then(() => 
        {
            this.intoUpgrade();
        }).catch(() => {});
    },
    intoUpgrade()
    {
        this.$confirm(this.$i18n.t("update.localhost.confirmInfoUpdate"), this.$i18n.t("update.localhost.confirmTitUpdate"), 
        {
          confirmButtonText: this.$i18n.t("update.localhost.confirmOKUpdate"),
          cancelButtonText: this.$i18n.t("update.localhost.confirmNoUpdate"),
          type: 'warning'
        }).then(() => 
        {
            this.bootMode();
            this.$message({message:this.$i18n.t("update.infoBoot"),type: 'warning',center: true,offset:300,'show-icon':true});

        }).catch(() => {});
    },
    async startUpgrade()
    {
      this.showProgress = true;

      this.showCheck = false;
      this.showBoot = false;
      this.showStart = false;

      this.readBinFile();

      await ToolsHandle.delay(1000);
      //签名
      let SNDatas = this.HIDDeviceObj.SNDatas;
      let SNSignDatas = HIDDeviceUpgradeObj.blSignature(SNDatas,HIDDeviceUpgradeObj.blSignatureKey,HIDDeviceUpgradeObj.blSignatureParams,0x02);

      let SIGN1_CMD = new Uint8Array(cmd10.SET_DEVICE_SIGN1_CMD.map(hex => parseInt(hex, 16)));
          SIGN1_CMD = this.HIDDeviceObj.mergeUint8Arrays([SIGN1_CMD,[0x10],SNSignDatas,[0x10],SNDatas,[0xFF,0xFF,0xFF,0xFF]]);
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN1_CMD);

      await ToolsHandle.delay(20);
      let SignSN = this.HIDDeviceObj.SignDatas;
      let SignDatas = HIDDeviceUpgradeObj.blSignature(SignSN,HIDDeviceUpgradeObj.blSignatureKey,HIDDeviceUpgradeObj.blSignatureParams,0x03);

      let SIGN2_CMD = new Uint8Array(cmd10.SET_DEVICE_SIGN2_CMD.map(hex => parseInt(hex, 16)));
          SIGN2_CMD = this.HIDDeviceObj.mergeUint8Arrays([SIGN2_CMD,[0x10],SignDatas,[0x10],SignSN,[0xFF,0xFF,0xFF,0xFF]]);
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN2_CMD);

      //擦除
      await ToolsHandle.delay(20);
      let ERASE_CMD =  HIDDeviceUpgradeObj.getFirmwareBufferLenCommand(this.FirmwareBuffer.length,cmd10);
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, ERASE_CMD);
      await ToolsHandle.delay(100);

      //签名
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN1_CMD);
      await ToolsHandle.delay(100);

      SignSN = this.HIDDeviceObj.SignDatas;
      SignDatas = HIDDeviceUpgradeObj.blSignature(SignSN,HIDDeviceUpgradeObj.blSignatureKey,HIDDeviceUpgradeObj.blSignatureParams,0x06);

      let SIGN5_CMD = new Uint8Array(cmd10.SET_DEVICE_SIGN5_CMD.map(hex => parseInt(hex, 16)));
          SIGN5_CMD = this.HIDDeviceObj.mergeUint8Arrays([SIGN5_CMD,[0x10],SignDatas,[0x10],SignSN,[0xFF,0xFF,0xFF,0xFF]]);

      this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN5_CMD);
      await ToolsHandle.delay(20);

      //写入固件数据
      let context = this;
      let firmwareBufferCommand = HIDDeviceUpgradeObj.getFirmwareBufferCommand(context.FirmwareBuffer,cmd10);
      for(let i in firmwareBufferCommand)
      {
        for(let j in firmwareBufferCommand[i])
        {
          const outputReportData = firmwareBufferCommand[i][j];
          context.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

          await ToolsHandle.delay(10);
        }

        if(i%4 == 0 && context.percentage < 100)
        {
          context.percentage++;
        }
      }


      await ToolsHandle.delay(100);
      //签名
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN1_CMD);
      await ToolsHandle.delay(100);

      SignSN = this.HIDDeviceObj.SignDatas;
      SignDatas = HIDDeviceUpgradeObj.blSignature(SignSN,HIDDeviceUpgradeObj.blSignatureKey,HIDDeviceUpgradeObj.blSignatureParams,0x05);

      let SIGN6_CMD = new Uint8Array(cmd10.SET_DEVICE_SIGN6_CMD.map(hex => parseInt(hex, 16)));
          SIGN6_CMD = this.HIDDeviceObj.mergeUint8Arrays([SIGN6_CMD,[0x10],SignDatas,[0x10],SignSN,[0xFF,0xFF,0xFF,0xFF]]);

      this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN6_CMD);
      await ToolsHandle.delay(500);

      //获取固件CRC
      const SIGN_CRC_CMD = HIDDeviceUpgradeObj.getFirmwareCRCCommand(this.FirmwareBuffer.length,cmd10);
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN_CRC_CMD);
      await ToolsHandle.delay(300);

      let firmwareCRC = (parseInt(this.HIDDeviceObj.SignCRC[1]) << 8) + parseInt(this.HIDDeviceObj.SignCRC[0]);
      let bufferCRC =  HIDDeviceUpgradeObj.crc16(this.FirmwareBuffer);

      console.log("CRC:" + this.HIDDeviceObj.SignCRC);
      console.log("CRC:" + firmwareCRC);
      console.log("bCRC:" + bufferCRC);
      //跳转
      if(firmwareCRC == bufferCRC)
      {
          const SIGN_APP_CMD = HIDDeviceUpgradeObj.getFirmwareToAppCommand(this.FirmwareBuffer.length,this.HIDDeviceObj.SignCRC,cmd10);
          this.HIDDeviceObj.curDeviceHandle.sendReport(0, SIGN_APP_CMD);

          //更新完成
          this.active = 3;
          this.$message({message:this.$i18n.t("update.infoComplete"),type: 'success',center: true,offset:300,'show-icon':true});
      }
      else
      {
          this.$message({message:this.$i18n.t("update.CRC"),duration:0,type: 'error',center: true,offset:300,'show-icon':true});
          await this.startUpgrade();
      }

    },
    upgradeSuccess()
    {
        this.$emit("child-event");
    },
    readBinFile() 
    {
      let path = require("../../theme/drives/" + this.modelNumber + "/asserts/bin/last.bin");

      axios({
          method: 'GET',
          responseType: 'arraybuffer',
          url:path.default,
        })
      .then(response => 
      {
          const fileContent = response.data; // 文件内容
          // 将ArrayBuffer转换为Uint8Array
          const uint8Array = new Uint8Array(fileContent);
          this.FirmwareBuffer = HIDDeviceUpgradeObj.padTo512(uint8Array);

        })
        .catch(error => {
          console.error(error);
        });
    }

  }
}
</script>